import { usePropertyStructureType } from '../../../queries/PropertyFields/TopLevelFields';
import { usePropertyNumberUnits } from '../../../queries/PropertyFields/NonRentalCoreFields';
import * as Store from '@apply/store';
import { DropDownBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface StructureTypeProps {
    propertyGuid: string;
    isReview?: boolean;
    onValueChange?: (value: string) => void;
}

export const StructureType: React.FC<StructureTypeProps> = ({ propertyGuid, isReview = false, onValueChange }) => {
    const [structureType, set_structureType] = usePropertyStructureType(propertyGuid);
    const [, set_units] = usePropertyNumberUnits(propertyGuid);

    const nonRentalStructureTypeValues = [
        { display: '', value: '' },
        ...Store.PropertiesStore.Types.nonRentalStructureTypes.map((st) => {
            return {
                display: st.toString(),
                value: st.toString(),
            };
        }),
    ];

    const onChangeStructureType = (value) => {
        onValueChange?.(value);
        set_structureType(value);
        switch (value) {
            case Store.PropertiesStore.Types.nonRentalStructureTypes[0]:
            case Store.PropertiesStore.Types.nonRentalStructureTypes[1]:
                set_units(1);
                return;
            case Store.PropertiesStore.Types.nonRentalStructureTypes[2]:
                set_units(2);
                return;
            case Store.PropertiesStore.Types.nonRentalStructureTypes[3]:
                set_units(3);
                return;
            case Store.PropertiesStore.Types.nonRentalStructureTypes[4]:
                set_units(4);
                return;
            case Store.PropertiesStore.Types.nonRentalStructureTypes[5]:
                set_units(5);
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label='Property Structure'
                    value={structureType}
                />
            ) : (
                <DropDownBox
                    id='structureType'
                    value={structureType}
                    onChange={(value) => onChangeStructureType(value)}
                    label='Structure Type'
                    required={true}
                    dataSource={nonRentalStructureTypeValues}
                    valueExpr='value'
                    displayExpr='display'
                />
            )}
        </>
    );
};
